import { render } from "./detailsTable.vue?vue&type=template&id=2c320076&scoped=true"
import script from "./detailsTable.vue?vue&type=script&lang=js"
export * from "./detailsTable.vue?vue&type=script&lang=js"

import "./detailsTable.vue?vue&type=style&index=0&id=2c320076&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c320076"]])

export default __exports__